export default __webpack_public_path__ + "static/media/strategy-section-bg.5c79d8e4.png";